const isTestCafeInSessionStorage = () => sessionStorage.getItem('X-TestCafe') === 'hzQuVvBzsam9pGFdqUNCuTUS99zGu84bG';

export const isTestcafeEnabled = () => !!process.env.VUE_APP_API_BASE_TESTCAFE_URL &&
    isTestCafeInSessionStorage();
